var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"container openapp"},[_c('div',{staticStyle:{"padding":"20px"}},[_c('div',{staticClass:"btn btn-main mr-3",on:{"click":_vm.open1}},[_vm._v("Open 1")]),_c('div',{staticClass:"btn btn-main",on:{"click":_vm.open2}},[_vm._v("Open 2")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }